(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CONFIG = {
      lines: 4,
      moreLabel: 'Read more',
      lessLabel: 'Read less',
      // Classe du texte de l'avis (1er match utilise).
      selectors: [
        '.review__content',
        '.review-slide__content',
        '.review__text',
        '.review-card__text',
        '.review__body'
      ],
      // Classe du nom de l'auteur (le badge se colle a cote).
      authorSelectors: [
        '.review__author',
        '.review-slide__author',
        '.review__name',
        '.review-card__author'
      ],
      // Textes reconnus comme "verified".
      verifiedText: /^(verified|verifie|verifiee|verifie|verifiee)$/i
    };

    // Pastille checkmark (rond vert marque + coche blanche).
    var CHECK =
      '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true">' +
        '<circle cx="8" cy="8" r="8" fill="#3D5A47"/>' +
        '<path d="M4.5 8.2l2.2 2.2 4.3-4.6" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';

    /* ---- Read more (coupe a N lignes) ---- */
    function collect(root) {
      var sel = CONFIG.selectors.map(function (s) { return '.reviews ' + s; }).join(',');
      return (root || document).querySelectorAll(sel);
    }

    function clampOne(el) {
      if (el.dataset.clampInit) return;
      el.dataset.clampInit = '1';
      el.classList.add('js-review-clamp');
      el.style.webkitLineClamp = String(CONFIG.lines);

      requestAnimationFrame(function () {
        if (el.scrollHeight <= el.clientHeight + 2) {
          el.classList.remove('js-review-clamp');
          el.style.webkitLineClamp = '';
          return;
        }
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'review-readmore';
        btn.textContent = CONFIG.moreLabel;
        btn.addEventListener('click', function () {
          var open = el.classList.toggle('is-expanded');
          btn.textContent = open ? CONFIG.lessLabel : CONFIG.moreLabel;
        });
        el.insertAdjacentElement('afterend', btn);
      });
    }

    /* ---- Badge Verified a cote du nom ---- */
    function badgeOne(el) {
      if (el.dataset.vbInit) return;
      el.dataset.vbInit = '1';
      el.classList.add('review-verified');
      el.innerHTML = CHECK + '<span>Verified</span>';

      var card =
        el.closest('li, .splide__slide') ||
        el.closest('[class*="review"]') ||
        el.parentElement;
      if (!card) return;

      var author = null;
      for (var i = 0; i < CONFIG.authorSelectors.length; i++) {
        author = card.querySelector(CONFIG.authorSelectors[i]);
        if (author) break;
      }
      if (author && author !== el && !author.contains(el)) {
        author.appendChild(el);
      }
    }

    function findVerified(root) {
      var out = [];
      (root || document).querySelectorAll('.reviews *').forEach(function (el) {
        if (el.children.length === 0 && CONFIG.verifiedText.test((el.textContent || '').trim())) {
          out.push(el);
        }
      });
      return out;
    }

    function init(root) {
      collect(root).forEach(clampOne);
      findVerified(root).forEach(badgeOne);
    }

    document.addEventListener('DOMContentLoaded', function () { init(document); });
    // Re-init dans l'editeur de theme quand la section est rechargee.
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
